mutation EnableMultiFactorAuth($mfaProtocol: String!) {
  enableMultiFactorAuth(mfaProtocol: $mfaProtocol) {
    errors
    success
    qrCodeImg
    cellphone
  }
}
